import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { Skeleton } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { GROUP_ID } from '../../common/constants';
import type { RoleItem } from '../../common/types';
import RolesFilter from './roles-filter';
import type { RolesContainerProps } from './types';

export const RolesFilterContainer = (props: RolesContainerProps) => {
	const { roles, rolesFilter, onRoleChange, isFetching } = props;
	const { roleIds = [] } = rolesFilter;
	let mappedRoles: RoleItem[] = [];
	const onChange = (id: RoleItem['id'], isChecked: boolean): void => {
		if (id === GROUP_ID) {
			// Group
			onRoleChange('roleType', isChecked ? [id] : []);
		} else {
			// Sorting to make sure ordering remain the same
			const updatedRoleIds: number[] = isChecked
				? [...roleIds, +id].sort((a: number, b: number): number => (a > b ? 1 : -1))
				: roleIds.filter((rId) => rId !== id);
			onRoleChange('roleIds', updatedRoleIds);
		}
	};

	if (isFetching === true) {
		return (
			<SkeletonWrapper>
				<Skeleton height="32px" />
			</SkeletonWrapper>
		);
	}
	// merge responses
	if (!roles.loading && roles.data) {
		// Go the roles data
		mappedRoles = roles.data.map((role): RoleItem => {
			const { id, name, translatedName } = role;
			return { id, name, translatedName, isChecked: roleIds.indexOf(id) >= 0 };
		});
	}
	return <RolesFilter roles={mappedRoles} onChange={onChange} />;
};

RolesFilterContainer.displayName = 'RolesFilterContainer';

RolesFilterContainer.defaultProps = {
	isFetching: false,
};

export default RolesFilterContainer;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonWrapper = styled.div<{
	children?: ReactNode;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 12}px`,
});
